import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header, Footer } from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import StickyMobileCTA from './components/StickyMobileCTA';
import HomePage from './pages/HomePage';
import SeoPage from './pages/SeoPage';
import AtlasPage from './pages/AtlasPage';
import JobwechselPage from './pages/JobwechselPage';
import B2BPage from './pages/B2BPage';
import { DatenschutzPage, ImpressumPage } from './pages/LegalPages';
import './App.css';

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-white">
          <Header />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/jobwechsel-rechner" element={<JobwechselPage />} />
              <Route path="/fuer-arbeitgeber" element={<B2BPage />} />
              <Route path="/pendel-atlas" element={<AtlasPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/:slug" element={<SeoPage />} />
            </Routes>
          </div>
          <Footer />
          <StickyMobileCTA />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}
